import { render, staticRenderFns } from "./ProfileAffiliateCard.vue?vue&type=template&id=35c011bc&scoped=true&"
import script from "./ProfileAffiliateCard.vue?vue&type=script&lang=ts&"
export * from "./ProfileAffiliateCard.vue?vue&type=script&lang=ts&"
import style0 from "./ProfileAffiliateCard.vue?vue&type=style&index=0&id=35c011bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35c011bc",
  null
  
)

export default component.exports